import { useEffect, useState } from "react";
import { config, countries } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";
import { getCookie } from "../../utils/cookieHandler";

const useCustomersLogic = () => {
  const apiRoute = "contacts";
  const onlyForm = undefined;
  //Roles
  const captain = process.env.REACT_APP_CAPTAIN_ID;
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const clientRole = process.env.REACT_APP_CLIENT_ROLE;

  const currentRole1 = getCookie("_r");
  const isAdmin = currentRole1 === admin;
  const initFields = [
    {
      name: "customerInfoHeading",
      type: "simpleHeading",
      label: "Customer information",
      span: 1,
    },
    {
      name: "customerIdentificationHeading",
      type: "simpleHeading",
      label: "Customer identification",
      span: 1,
    },
    {
      name: "first_name",
      label: "First name",
      type: "text",
      isRequired: true,
      err: "First name is required",
      span: 3,
    },
    {
      name: "last_name",
      label: "Last name",
      type: "text",
      isRequired: true,
      err: "Last name is required",
      span: 3,
    },
    {
      name: "phone_number",
      label: "Phone Number",
      type: "phone",
      isRequired: true,
      err: "Phone number is required",
      span: 3,
    },
    {
      name: "files",
      label: " Files",
      type: "file",
      isRequired: false,
      err: "Files are required",
      isMulti: true,
      span: 1,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      err: "Email is required",
      isRequired: true,
      validation: {
        body: {
          email: "email",
        },
        confirmation: {
          exists: false,
        },
      },
      span: 3,
    },
    {
      name: "date_of_birth",
      label: "Date of birth",
      type: "datepicker",
      allowTime: false,
      span: 3,
    },
    {
      name: "branches",
      label: "Branches",
      type: "card",
      isRequired: false,
      // checkWithFiles: [
      //   {
      //     param: "contact",
      //     apiUrlRoute: "contacts",
      //   },
      // ],
      err: "Branches are required",
      span: 2,

      toShow: {
        title: "branch.Name,",
        id: "id",
        tempid: "tempid",
        status: "branch.email",
        createdBy: "",
        createdOn: "",
        delete: "delete",
      },
      rowActionsShowNew: true,

      exclude: {
        name: "delete",
        value: true,
      },
      formOptions: {
        label: "Add new branch",
        fields: [
          {
            name: "branch",
            label: "Existing branch",
            type: "dropdown",
            removeElementIfPreviouslyAdded: true,
            isRequired: true,
            err: "Existing branch is required",
            returnID: true,
            returnObject: true,
            span: 1,
            concat: true,
            concatBy: " ",
            lazyloadParam: "Name",
            lazyloadParam2: "code",
            lazyloadUrl: "branches",
          },
        ],
      },
    },
    {
      name: "nationality",
      label: "Nationality",
      type: "dropdown",
      data: countries,
      span: 3,
    },
    {
      name: "country",
      label: "Country",
      type: "dropdown",
      isRequired: false,
      err: "Country is required",
      data: countries,
      span: 3,
    },
    {
      name: "city",
      label: "City",
      type: "text",
      isRequired: false,
      err: "City is required",
      span: 3,
    },
    {
      name: "state",
      label: "State",
      type: "text",
      isRequired: false,
      err: "State is required",
      span: 3,
    },
    {
      name: "street1",
      label: "Street",
      type: "text",
      isRequired: false,
      err: "Street is required",
      span: 3,
    },
    {
      name: "id_number",
      label: "Identification number",
      type: "text",
      err: "Identification number is required",
      span: 2,
    },
    // {
    //   name: "balance",
    //   label: "Balance",
    //   type: "number",
    //   disabled: true,
    //   span: 3,
    // },
    {
      name: "id_number_expiry",
      label: "Identification expiry",
      type: "datepicker",
      allowTime: false,
      err: "Id number's expiry is required",
      span: 2,
    },
    {
      name: "company",
      label: "Company",
      type: "dropdown",
      isRequired: true,
      err: "Company is required",
      returnID: true,
      span: 3,
    },
    {
      name: "driver_license_number",
      label: "Driver's license number",
      type: "text",
      err: "Driver's license number is required",
      span: 2,
    },
    {
      name: "referred_by",
      label: "Referred by",
      type: "text",
      isRequired: false,
      err: "Referred by is required",
      span: 3,
    },
    {
      name: "driver_license_expiry",
      label: "Driver's license expiry",
      type: "datepicker",
      allowTime: false,
      err: "Driver's license expiry is required",
      span: 2,
    },
    {
      name: "driver_license",
      label: "Front: Driver's license",
      type: "file",
      isRequired: false,
      err: "Front: Driver's license is required",
      isMulti: false,
      span: 2,
    },
    {
      name: "driver_license_back",
      label: "Back: Driver's license",
      type: "file",
      isRequired: false,
      err: "Back: Driver's license is required",
      isMulti: false,
      span: 2,
    },
    {
      name: "id_document",
      label: "Front: Identification",
      type: "file",
      isRequired: false,
      err: "Front: Identification is required",
      isMulti: false,
      span: 2,
    },
    {
      name: "id_document_back",
      label: "Back: Identification",
      type: "file",
      isRequired: false,
      err: "Back: Identification is required",
      isMulti: false,
      span: 2,
    },
    {
      name: "statement",
      type: "statement",
      span: 5,
    },
    {
      name: "customerFinanceHeading",
      type: "simpleHeading",
      label: "Customer finances",
      span: 1,
    },
    {
      name: "total_balances",
      type: "collection_display",
      span: 1,
      withDefault: true,
    },
    {
      name: "custom_balances",
      label: "Custom balances",
      type: "card",
      isRequired: false,
      disableWhenDayEnds: true,
      useIndexAsKey: true,
      span: 2,
      headerAction: {
        name: "Add",
        id: "add",
      },
      toShow: {
        title:
          "description,<s> -,,<s> ,branch.Name,<s> -,,<s> ,branch.currency.code,<s> ,,<s> ,amount,<s> -,,<s> ,<d-lb>date",
        id: "id",
        tempid: "tempid",
        // status: "branch.email",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        delete: "delete",
      },
      rowActionsShowNew: true,

      exclude: {
        name: "delete",
        value: true,
      },

      rowActions: [
        {
          name: "Edit",
          id: "edit",
        },
        {
          name: "Delete",
          id: "update",
          data: {
            delete: true,
          },
        },
      ],
      formOptions: {
        label: "Add new Custom balance",
        fields: [
          {
            name: "branch",
            label: "Branch",
            type: "dropdown",
            isRequired: true,
            err: "Existing branch is required",
            returnID: true,
            returnObject: true,
            span: 1,
            // concat: true,
            // concatBy: " ",
            lazyloadParam: "Name",
            lazyloadParam2: "code",
            lazyloadUrl: "branches",
          },
          {
            name: "description",
            label: "Description",
            type: "text",
            minValue: 0,
            isRequired: true,
            err: "description is required",
            span: 1,
          },
          {
            name: "amount",
            label: "Amount",
            type: "number",
            minValue: 0,
            isRequired: true,
            err: "Amount is required",
            span: 1,
          },
          {
            name: "date",
            label: "Date",
            type: "datepicker",
            disableInput: true,
            countryCode: "LB", // USING LB HERE AND ON BACKEND since user can be both , let the calculation be unified
            allowTime: true,
            isRequired: true,
            reduceMinDateDays: 1,
            err: "Date is required",
            span: 1,
          },
          {
            name: "is_deduction",
            label: "Is deduction",
            type: "toggle",
            isRequired: false,
          },
        ],
      },
    },
    {
      name: "custom_orders",
      disableWhenDayEnds: true,
      label: "Custom orders",
      type: "card",
      isRequired: false,
      useIndexAsKey: true,
      span: 2,
      headerAction: {
        name: "Add",
        id: "add",
      },
      toShow: {
        title:
          "type.name,<s> -,,<s> ,branch.Name,<s> -,,<s> ,description,<s> -,,<s>,branch.currency.code,<s> ,,<s> ,amount+vat_amount,<s> -,,<s> ,<d-lb>date_created",
        id: "id",
        tempid: "tempid",
        // status: "branch.email",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        delete: "delete",
      },
      rowActionsShowNew: true,

      exclude: {
        name: "delete",
        value: true,
      },

      rowActions: [
        {
          name: "Edit",
          id: "edit",
        },
        {
          name: "Delete",
          id: "update",
          data: {
            delete: true,
          },
        },
      ],
      formOptions: {
        label: "Add new Custom balance",
        fields: [
          {
            name: "branch",
            label: "Branch",
            type: "dropdown",
            isRequired: true,
            err: "Existing branch is required",
            returnID: true,
            returnObject: true,
            disableOnAction: "edit",
            span: 1,
            // concat: true,
            // concatBy: " ",
            lazyloadParam: "Name",
            lazyloadParam2: "code",
            lazyloadUrl: "branches",
          },
          {
            name: "type",
            label: "Type",
            type: "dropdown",
            isRequired: true,
            err: "Type is required",
            disableOnAction: "edit",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "contacts/customorderstypes",
          },
          {
            name: "description",
            label: "Description",
            type: "text",
            minValue: 0,
            isRequired: true,
            err: "description is required",
            span: 1,
          },
          {
            name: "amount",
            label: "Amount",
            type: "number",
            minValue: 0,
            isRequired: true,
            err: "Amount is required",
            span: 1,
          },

          {
            name: "bill_to_company",
            label: "Bill to company",
            disabledIfNotField: {
              field: "company.name",
              isNotEqual: [null],
            },
            type: "toggle",
            isRequired: false,
            defaultValue: true,
            disabled: true,
          },
          {
            name: "includes_vat",
            label: "Add VAT",
            type: "toggle",
            isRequired: false,
          },
        ],
      },
    },
  ];
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole, clientRole];
  const deleteRoles = [admin, managerRole, financeRole];
  const editRoles = [admin, managerRole, financeRole, clientRole];

  const tabs = [
    {
      name: "Details",
      href: "#",
      current: true,
      allowedRoles: [admin, managerRole, financeRole, clientRole],
      fields: [
        "customerInfoHeading",
        "first_name",
        "last_name",
        "phone_number",
        "email",
        "date_of_birth",
        "nationality",
        "country",
        "city",
        "state",
        "street1",
        "company",
        "referred_by",
        // "balance",
        "customerIdentificationHeading",
        "id_number",
        "id_number_expiry",
        "id_document",
        "id_document_back",
        "driver_license_number",
        "driver_license_expiry",
        "driver_license",
        "driver_license_back",
        "customerFinanceHeading",
        "total_balances",
        "custom_balances",
        "custom_orders",
        "branches",
        "files",
      ],
    },
    {
      name: "Statement",
      href: "#",
      current: false,
      allowedRoles: [admin, managerRole, financeRole, clientRole],
      fields: ["statement"],
    },
  ];

  const getPromises = (temp) => {
    return [fetchDataAndMapToField(config, "companies", "company", temp)];
  };

  const [tabsData, setTabsData] = useState([]);

  useEffect(() => {
    var interval = setInterval(async function () {
      const currentRole = await waitForCookie("_r");
      // Check if the variable is loaded
      if (currentRole) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabsData(__tabs);
        // Delete the interval
        clearInterval(interval);
      }
    }, 100); // Check every 100 milliseconds

    return () => {
      setTabsData([]);
    };
  }, []);

  return {
    addRoles,
    editRoles,
    deleteRoles,
    getPromises,
    initFields,
    tabs,
    tabsData,
    apiRoute,
    onlyForm,
  };
};

export default useCustomersLogic;
